import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "our-select"
};
var _hoisted_2 = ["disabled"];
var _hoisted_3 = { class: "btn__label" };
var _hoisted_4 = { class: "btn__icon" };
var _hoisted_5 = ["open"];
var _hoisted_6 = { class: "our-select__list" };
var _hoisted_7 = ["disabled", "onClick"];
import { ref } from "vue";
import Sprite from "../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sorting',
    props: {
        type: { type: String, required: true },
        types: { type: Object },
        current: String,
        enabled: Boolean,
    },
    emits: ["change"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var open = ref(false);
        var emit = __emit;
        function select(code) {
            open.value = false;
            if (code !== props.type) {
                emit('change', code);
            }
        }
        return function (_ctx, _cache) {
            return (__props.enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "btn btn--m btn--4 btn--link our-select__current",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (open.value = !open.value); }),
                        disabled: !__props.enabled
                    }, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.current), 1 /* TEXT */),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_4, [
                            _createVNode(Sprite, { name: "arrow-down" })
                        ])
                    ], 8 /* PROPS */, _hoisted_2),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("dialog", {
                        class: "our-select__dialog",
                        open: open.value
                    }, [
                        _createElementVNode("ul", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.types, function (title, code) {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: code,
                                    class: "our-select__item"
                                }, [
                                    _createElementVNode("button", {
                                        class: _normalizeClass(["our-select__btn", { 'is-selected': __props.type === code }]),
                                        type: "button",
                                        disabled: !__props.enabled,
                                        onClick: _withModifiers(function ($event) { return (select(code)); }, ["prevent"])
                                    }, _toDisplayString(title), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ], 8 /* PROPS */, _hoisted_5)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
